import BranchAgentTicketsPerService from "../../../components/branches/reports/daily/BranchAgentTicketsPerService";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyBranchAgentTicketsPerService = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    branchScoped={true}
    reportTypeId={REPORT_TYPE_IDS.daily_branch_agent_tickets_per_service}
    title="Agent Tickets Per Service"
    helmetTitle="Daily Branch Agent Tickets Per Service"
    descriptionKey="AgentTicketsByService"
    columnDefinitions={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <BranchAgentTicketsPerService
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyBranchAgentTicketsPerService;
